
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";

@Component
export default class SitemapSectionItemPage extends Vue {
  $message: any;
  $confirm: any;

  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "sitemapSection",
  });

  createItemModel: any = {
    sectionId: +this.$route.params.id,
    title: "",
    url: "/",
    isAuto: false,
    isActive: true,
    instanceStateId: 4,
  };

  createItemFields: any[] = [
    {
      name: "title",
      editor: "string",
      attrs: { type: "text", label: "Заголовок ссылки" },
      validations: [{ validator: "required" }],
    },
    {
      name: "url",
      editor: "string",
      attrs: { type: "text", label: "URL (например /doctors/ivanov/)" },
      validations: [{ validator: "required" }],
    },
    {
      name: "isAuto",
      editor: "bool",
      attrs: { label: "Автоссылка" },
      validations: [],
    },
    {
      name: "isActive",
      editor: "bool",
      attrs: { label: "Активна" },
      validations: [],
    },
    {
      name: "sourceComponentId",
      editor: "number",
      attrs: { type: "number", label: "ID источника (необязательно)" },
      validations: [],
    },
  ];

  itemsDataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 200,
      orderFieldName: "Priority",
      orderFieldDirection: "ASC",
      filter: JSON.stringify([new Filter("sectionId", +this.$route.params.id)]),
    },
    className: "sitemapItem",
  });

  async loadPreview() {
    try {
      const payload = {
        autoSourceType: this.dataSource.model?.autoSourceType ?? 0,
        autoSourceClassId: this.dataSource.model?.autoSourceClassId ?? null,
        autoLimit: this.dataSource.model?.autoLimit ?? 0,
      };
      const { data } = await axios.post(
        `/manage/sitemapSection/${this.$route.params.id}/preview-auto`,
        payload,
      );
      const previewItems = (data?.items ?? []).map((i: any) => ({
        selected: true,
        ...i,
      }));

      if (previewItems.length === 0) {
        this.$message("Для выбранного автоисточника данные не найдены");
        return;
      }

      const html = previewItems
        .slice(0, 20)
        .map((i: any) => `<li>${i.title} (${i.url})</li>`)
        .join("");
      const hasMore = previewItems.length > 20 ? `<li>... и еще ${previewItems.length - 20}</li>` : "";

      const ok = await this.$confirm({
        title: "Предпросмотр автозагрузки",
        text: `<div>Найдено ${previewItems.length} ссылок.<br/>Применить автозагрузку?<ul>${html}${hasMore}</ul></div>`,
        isHtml: true,
      });

      if (!ok) return;

      await axios.post(`/manage/sitemapSection/${this.$route.params.id}/apply-auto`, {
        items: previewItems
          .filter((i: any) => i.selected)
          .map((i: any) => ({
            sourceComponentId: i.sourceComponentId,
            title: i.title,
            url: i.url,
            isAuto: true,
          })),
      });

      await this.itemsDataSource.get();
      this.$message("Автозагрузка применена");
    } catch (e: any) {
      this.$message(e?.message ?? "Ошибка автозагрузки");
    }
  }

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Карта сайта",
        to: "/manage/sitemapSection/",
        exact: true,
      },
      {
        text: this.dataSource.model?.caption,
        disabled: true,
      },
    ];
  }
}
